<div class="flex flex-col gap-2 h-full">
  <div class="px-3">
    <div class="flex justify-end mb-2">
      <button
        kendoButton
        themeColor="tertiary"
        iconClass="fa-icons icon-book-sparkles icon-16"
        [disabled]="isLoading()"
        (click)="openLibrary.emit()"
      >
        {{ 'outlook.iqBoost.questionLibrary' | translate }}
      </button>
    </div>

    @if (prompt()) {
      <div
        class="p-2 flex gap-2 items-center justify-between bg-bush-green-10 rounded"
      >
        <p class="text-body large text-neutral-90">
          {{ prompt() }}
        </p>
      </div>
    }
  </div>
  <!-- Results -->
  @if (isLoading()) {
    <div class="flex flex-1 min-h-0 items-center justify-center">
      <maximizer-outlook-iq-boost-loader></maximizer-outlook-iq-boost-loader>
    </div>
  } @else if (aiResponse()) {
    <div
      class="ai-response flex-1 min-h-0 scrollbar overflow-y-auto overflow-x-hidden text-body-2 text-neutral-90 p-3 break-words"
      kendoTooltip
      filter="[data-type]"
      [tooltipTemplate]="tooltipTemplate"
      [callout]="false"
      [innerHTML]="
        aiResponse()
          | markdownRendering
          | outlookDeAnonymizer
          | outlookClickableRef
          | outlookCreateCRMObject
          | outlookEntityKeyRef
          | safeHtml
      "
    ></div>
  } @else if (error()) {
    <div class="flex flex-col items-center justify-center h-full gap-3 p-4">
      <img
        [alt]="'outlook.iqBoost.error.generic' | translate"
        class="w-20"
        [src]="cdn + '/assets/images/error-state.svg'"
      />
      <p class="text-body text-neutral-70 text-pretty text-center">
        {{ errorMessage()! | translate }}
      </p>
      @if (canRetry()) {
        <button kendoButton themeColor="primary" (click)="retry()">
          {{ 'outlook.iqBoost.error.retry' | translate }}
        </button>
      }
    </div>
  } @else {
    <div class="flex flex-col items-center justify-center h-full gap-2 p-4">
      <img
        [alt]="'outlook.shared.component.noResults' | translate"
        class="w-20"
        [src]="cdn + '/assets/images/empty-container.svg'"
      />
      <p class="text-body text-neutral-70 text-pretty text-center">
        {{ 'outlook.iqBoost.emptyStateSummary' | translate }}
      </p>
    </div>
  }
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
